export default {"src":"/_next/static/image/public/images/check2.0afe31a1a9079b38417e9b7407b395fa.svg","height":32,"width":32};